import getAssetPath from '$utils/getAssetPath';

export default {
    props: {

    },
    components: {},

    data() {
        return {

        }
    },

    methods: {
        getAssetPath,
        switchTab(close) {
            window.location.hash = '#heatmap'
            close()
        },
        openHeatmap(item, close) {
            close()

            const url = item.data?.url
            if (!url) {
                window.location.hash = '#heatmap'
                return
            }

            this.$router.push(url).catch(() => {
                window.location.hash = '#heatmap'
            })
        }
    }
}